<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
const seat = ref('')
const status = ref('')
const number = ref('')
const loading = ref(false)
const isError = ref(false)
const errorField = ref('')

const errorFieldMap = {
  'InvalidParameterValue.InstanceNotExist': 'sdkAppId',
  'InvalidParameterValue.AccountNotExist': 'userId',
  'AuthFailure.SignatureFailure': 'secretKey或secretId',
  'AuthFailure.SecretIdNotFound': 'secretId',
};

const injectTCCC = ({ token, sdkAppId, userId, sdkUrl }) => {
  const scriptDom = document.createElement('script')
  scriptDom.setAttribute('crossorigin', 'anonymous')
  scriptDom.dataset.token = token
  scriptDom.dataset.sdkAppId = sdkAppId
  scriptDom.dataset.userid = userId
  scriptDom.src = sdkUrl
  document.body.appendChild(scriptDom)
  scriptDom.addEventListener('load', () => {
    // ready事件必须监听，否则容易发生tccc不存在的错误，所有呼入呼出的逻辑必须在ready事件触发后才可以调用
    window.tccc.on('ready', () => {
      // 以下为Demo逻辑，非业务必须。业务代码主要实现都在这个部分
      const statusVal = window.tccc.Agent.getStatus()
      status.value = statusVal;
      seat.value = userId;
    })
    // 以下为Demo逻辑，非接入必须
    setInterval(() => {
      const statusVal = window.tccc.Agent.getStatus()
      status.value = statusVal;
    }, 200)
  })
}

onMounted(() => {
  // 获取Token的方法必须在页面初始化时第一优先级调用
  console.log(123123123);
  getToken();


})

const getToken = () => {
  let page = sessionStorage.getItem('loginPage');
  if(page == '/arealogin'){
    return;
  }
  axios.get('/api/house/admin/tcc/get-token').then((res) => {
    if (res.code == 200) {
      let tcc_token = res.data;
      // 调用成功后才可以开始执行TCCC的注入
      injectTCCC({
        token: tcc_token.token,
        userId: tcc_token.userId,
        sdkUrl: tcc_token.SdkURL,
        sdkAppId: tcc_token.sdkAppId,
      })
    }
  })



}

const handleCallout = async () => {
  if (loading.value) {
    return
  }
  loading.value = true
  // 调用呼出方法的核心代码
  try {
    await window.tccc.Call.startOutboundCall({ phoneNumber: number.value })
  } catch (error) {
    console.error(`呼出失败：${error.message}`)
  } finally {
    loading.value = false
  }
}

</script>

<template>
  <div class="container">

  </div>
</template>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.section {
  font-size: 14px;
  color: #333;
}

.container a {
  color: #10a37f;
}

.title {
  width: 100%;
  font-size: 36px;
  font-weight: 400;
  text-align: center;
  padding: 20px 0;
  color: #333;
}

.subTitle {
  font-size: 20px;
  font-weight: 400;
  width: 100%;
  text-align: left;
  color: #333;
}

.subTitle1 {
  font-size: 20px;
  font-weight: 400;
  width: 100%;
  text-align: left;
  color: #333;
  padding: 30px 0;
}

.link {
  font-size: 14px;
  color: #3FCFB8;
  text-decoration: none;
}

.text {
  font-size: 14px;
  width: 100%;
  text-align: left;
  padding: 10px 0;
  color: #333;
}

.button {
  background-color: #10a37f;
  color: #fff;
  width: 142px;
  height: 50px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}

.input {
  width: 306px;
  height: 50px;
  border: 1px solid #10a37f;
  border-radius: 5px;
  margin-right: 20px;
  padding-left: 10px;
}

.section {
  width: 500px;
  margin: 15px 0;
  align-items: flex-start;
}

.group {
  font-size: 14px;
  color: #333;
  margin-top: 10px;
}

.list {
  font-size: 14px;
  margin: 10px 0;
  color: #333;
}

.bottomSection {
  position: absolute;
  right: 68px;
  bottom: 24px;
  text-align: start;
  box-sizing: border-box;
  pointer-events: none;
  user-select: none;
}

.clickHint {
  font-size: 14;
  color: #bcbcbc;
  width: 100%;
  margin-bottom: -10;
}

.globalErrorContainer {
  flex-direction: column;
  justify-content: flex-start;
}

.listItem {
  line-height: 50px;
  color: #666;
  width: 800px;
  font-size: 14px;
}

.listBottom {
  padding: 20px 0;
  line-height: 40px;
  color: #666;
  width: 500px;
  font-size: 14px;
}
</style>